import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorLogComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorLogComponent, _React$Component);

  var _super = _createSuper(ErrorLogComponent);

  function ErrorLogComponent() {
    var _this;

    _classCallCheck(this, ErrorLogComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false
    });

    return _this;
  }

  _createClass(ErrorLogComponent, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this$props = this.props,
          logger = _this$props.logger,
          level = _this$props.level,
          onError = _this$props.onError;
      logger[level](error, {
        message: error.message,
        reactInfo: errorInfo.componentStack
      });
      this.setState({
        hasError: true
      });

      if (onError) {
        onError(error, errorInfo);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        if (this.props.errorStub) {
          return this.props.errorStub;
        } else {
          return /*#__PURE__*/_jsx("span", {});
        }
      }

      return this.props.children;
    }
  }, {
    key: "tryRender",
    value: function tryRender() {
      this.setState({
        hasError: false
      });
    }
  }]);

  return ErrorLogComponent;
}(React.Component);

_defineProperty(ErrorLogComponent, "defaultProps", {
  level: 'error'
});